import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadService } from '../orthofilelisting/service/upload.service'
import {Location} from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ortho-processing',
  templateUrl: './ortho-processing.component.html',
  styleUrls: ['./ortho-processing.component.css']
})
export class OrthoProcessingComponent implements OnInit {

  title = 'Raster Upload';
  file: any = {}
  fileUpload: string = 'block'
  dis: string = 'hidden';
  prg: string = 'none'
  xCoodinate: any;
  yCoodinate: any;
  myResImage: any;
  processdis: string = 'none'
  xWidth: any;
  yHeight: any;
  rWidth: any;
  rHeight: any;
  radius: any = 15;
  towerName: any;
  siteID: any;
  year: any;
  prs: any;
  progress = {
    currentStep: 0,
    totalStep: 5,
    progress: 0
  };
  role: any;
  

  constructor(private snackBar: MatSnackBar,private router: Router,private apiService: UploadService,private http: HttpClient,private route: ActivatedRoute,private _location: Location) { 
   this.getData()
   this.role = router.url.trim().split("/")[1]
   
  }

  ngOnInit(): void {
    console.log(this.route.snapshot.paramMap.get('path'))
    this.myResImage = "https://api1.phicode.co/static/"+ this.route.snapshot.paramMap.get('path')
  }

  //generate coordinates of image on click image
  getCordinate(event: any, img: any){
    console.log(event)  
    console.log(event.offsetX) 
    console.log(event.offsetY)
    console.log(img.clientWidth)
    console.log(img.clientHeight)
    this.xWidth = img.clientWidth
    this.yHeight = img.clientHeight
    this.xCoodinate = Math.round(event.offsetX * ( this.rWidth / this.xWidth))
    this.yCoodinate = Math.round(event.offsetY * ( this.rHeight / this.yHeight))
  }

  //uplaoding the ortho image to dbs
  async OnUpload()
  {
    this.prs = 'none'
    console.log("File selected")
    this.processdis = 'block'
    const formData = new FormData();
    formData.append('imagepath',this.myResImage.split("/").at(-1))
    formData.append('xc',this.xCoodinate)
    formData.append('yc',this.yCoodinate)
    formData.append('cxc',this.xWidth)
    formData.append('cyc',this.yHeight)
    formData.append('rad',this.radius)
    formData.append('filename', this.towerName)
    formData.append('tiffmode', 'Telstra')
    return this.http.post('https://api1.phicode.co/upload', formData, {responseType: 'json'}).subscribe((res: any) => {
      console.log(res)
      if(res.status == "success"){
        this.processdis = 'none'
        this.dis = 'visible'
        this.prs = 'block'
        this.router.navigate([this.role + '/' + this.year + '/' + this.towerName + '/orthomap'])
      }
      else if(res.status == "error"){
        this.processdis = 'none'
        this.dis = 'none'
        this.prs = 'block'
        this.snackBar.open('Processing failed,Please Try again', 'close', {
          duration: 2000,
        });
      }
    });
  }

  //uplaoding the ortho image to dbs
  OnSUpload()
  {
    this.prs = 'none'
    this.prg = 'block'
    const formData = new FormData();
    formData.append('imagepath', this.myResImage.split("/").at(-1))
    formData.append('xc', this.xCoodinate)
    formData.append('yc', this.yCoodinate)
    formData.append('cxc', this.xWidth)
    formData.append('cyc', this.yHeight)
    formData.append('filename', this.towerName)
    formData.append('rad', this.radius)
    formData.append('tiffmode', 'Telstra')
    formData.append('yr', this.year)
    this.http.post('https://api1.phicode.co/tifProcessing', formData, {responseType: 'json'}).subscribe((res: any) => {
      console.log(res)
      if(res.status == 'success'){
        this.router.navigate([this.role + '/' + this.year + '/' + this.towerName + '/orthomap'])
      }
      else if(res.status == "error"){
       this.snackBar.open('Image Processing failed,Please Try again', 'close', {
         duration: 2000,
       });
       this.prg = 'none'
       this.prs = 'block'
      }
    })
  }

  getData(){
    this.route.queryParams.subscribe(params => {
      console.log(params);
      this.rWidth = params.rWidth
      this.rHeight = params.rHeight
    });
    this.route.params.subscribe(params => {
      console.log(params);
      this.towerName = params.tower
      this.year = params.year;
    });
  }

  goBack(){
    this._location.back();
  }

}
